/*
 * -----------------------------------------------------------------------
 *  <copyright file="items-per-page/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2022 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { ItemsPerPageProps } from './items-per-page.interface';
import './styles.scss';
import { RadioGroup } from '@progress/kendo-react-inputs';

const controls = [
    {
        label: '5',
        value: 5,
    },
    {
        label: '10',
        value: 10,
    },
    {
        label: '25',
        value: 25,
    },
    {
        label: '50',
        value: 50,
    },
    {
        label: '100',
        value: 100,
    },
];

const ItemsPerPage = ({ value, onChange }: ItemsPerPageProps) => (
    <div className="items-per-page">
        <RadioGroup data={controls} value={value} onChange={onChange} />
    </div>
);

export default ItemsPerPage;
